module.exports = __webpack_public_path__ + "static/media/country_sv.8c22b871.webp";